import store from "../store";
import { loadSsoConfig, mustUseSsoOnly, redirectToSsoLogin } from "../helper/sso";
import { clearClientSession, hasStoredAccessToken, } from "../helper/sessionRedirect";
import { hasPendingHubSunset } from "../helper/hubSunset";
const LOGIN_ROUTE_NAMES = new Set(["Login", "AgencyLogin"]);
function authUserId() {
    const state = store.state;
    return state.auth?.user?.id;
}
export default async function guest({ next, router, to, }) {
    const isLoginRoute = LOGIN_ROUTE_NAMES.has(String(to.name || ""));
    if (isLoginRoute) {
        await loadSsoConfig().catch(() => undefined);
    }
    if (isLoginRoute && hasStoredAccessToken()) {
        const hasUser = !!authUserId();
        if (!hasUser) {
            clearClientSession();
            const { resetSsoConfigCache } = await import("../helper/sso");
            resetSsoConfigCache();
        }
        else if (store.getters.isAuthenticated) {
            if (hasPendingHubSunset()) {
                return router.replace({ name: "HubSunset" });
            }
            return router.push({ name: "New Feeds" });
        }
    }
    else if (!isLoginRoute && store.getters.isAuthenticated && authUserId()) {
        if (hasPendingHubSunset()) {
            return router.replace({ name: "HubSunset" });
        }
        return router.push({ name: "New Feeds" });
    }
    if (!isLoginRoute) {
        return next();
    }
    const cfg = await loadSsoConfig();
    if (cfg && cfg.enabled) {
        const mayHaveSsoCookie = typeof document !== "undefined" &&
            /(?:^|;\s*)social_session=/.test(document.cookie);
        if (mustUseSsoOnly(cfg) || mayHaveSsoCookie) {
            try {
                const boot = await store.dispatch("bootstrapSso");
                if (boot && boot.status) {
                    if (hasPendingHubSunset()) {
                        return router.replace({ name: "HubSunset" });
                    }
                    return router.push({ name: "New Feeds" });
                }
            }
            catch {
                /* continue */
            }
        }
        if (mustUseSsoOnly(cfg)) {
            redirectToSsoLogin(cfg);
            return;
        }
    }
    return next();
}
